import { bindMethod } from 'helpers/bind';
import PanelPage from 'navigation/pages/PanelPage';
import store from 'store';
export default class BundleSelectColor extends PanelPage {
    initialized() {
        super.initialized();
        this.el.parentElement.style.setProperty('--color-header-height', `${this.refs.selectColorHeader.offsetHeight}px`);
    }
    bindEvents(add) {
        super.bindEvents(add);
        const method = bindMethod(add);
        Array.from(this.refs.list.children).forEach((card) => card[method]('click', this.onCardClick));
    }
    onCardClick = (e) => {
        const card = e.currentTarget;
        if (!card.classList.contains('current')) {
            const detail = { index: Number(this.refs.list.dataset.index), productId: card.dataset.id };
            window.dispatchEvent(new CustomEvent('bundle:update-color', { detail }));
        }
        store.panel.set(null);
    };
}
